module.exports = __webpack_public_path__ + "img/1 (52).7fbc0623.png";